<template>
    <div>
        <v-row>
            <v-col v-if="showPanels" md="12">
                <v-row>
                    <v-col md="3">
                        <v-card color="blue-grey-darken-1" variant="flat" class="text-center">
                            <template v-slot:subtitle>
                                LAST 3 MONTHS
                                <hr />
                            </template>
                            <template v-slot:text>
                                <v-skeleton-loader v-if="recordLoading" type="avatar"></v-skeleton-loader>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.salesLast3Months, 2) }}</h2>
                                <div class="v-card-subtitle">
                                    <small>AVG. $/Ph</small>
                                </div>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.salesLast3MonthsDollarsPerHour, 2) }}</h2>
                                <div class="v-card-subtitle">
                                    <small>AVG. JobScore</small>
                                </div>
                                <h2 v-if="!recordLoading"><job-score :score="record.salesLast3MonthsScore"></job-score></h2>
                            </template>
                        </v-card>
                    </v-col>
                    <v-col md="3">
                        <v-card color="cyan-darken-1" variant="flat" class="text-center">
                            <template v-slot:subtitle>
                                LAST 6 MONTHS
                                <hr />
                            </template>
                            <template v-slot:text>
                                <v-skeleton-loader v-if="recordLoading" type="avatar"></v-skeleton-loader>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.salesLast6Months, 2) }}</h2>
                                <div class="v-card-subtitle">
                                    <small>AVG. $/Ph</small>
                                </div>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.salesLast6MonthsDollarsPerHour, 2) }}</h2>
                                <div class="v-card-subtitle">
                                    <small>AVG. JobScore</small>
                                </div>
                                <h2 v-if="!recordLoading"><job-score :score="record.salesLast6MonthsScore"></job-score></h2>
                            </template>
                        </v-card>
                    </v-col>
                    <v-col md="3">
                        <v-card color="indigo-accent-2" variant="flat" class="text-center">
                            <template v-slot:subtitle>
                                LAST 12 MONTHS
                                <hr />
                            </template>
                            <template v-slot:text>
                                <v-skeleton-loader v-if="recordLoading" type="avatar"></v-skeleton-loader>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.salesLast12Months, 2) }}</h2>
                                <div class="v-card-subtitle">
                                    <small>AVG. $/Ph</small>
                                </div>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.salesLast12MonthsDollarsPerHour, 2) }}</h2>
                                <div class="v-card-subtitle">
                                    <small>AVG. JobScore</small>
                                </div>
                                <h2 v-if="!recordLoading"><job-score :score="record.salesLast12MonthsScore"></job-score></h2>
                            </template>
                        </v-card>
                    </v-col>
                    <v-col md="3">
                        <v-card color="amber-lighten-4" variant="flat" class="text-center">
                            <template v-slot:subtitle>
                                WIP
                                <hr />
                            </template>
                            <template v-slot:text>
                                <v-skeleton-loader v-if="recordLoading" type="avatar"></v-skeleton-loader>
                                <h2 v-if="!recordLoading">${{ numberWithCommas(record.currentWIP, 2) }}</h2>
                            </template>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col md="12">
                <div style="height:250px; width:100%;" class="pa-3">
                    <Line :data="lineData" :options="lineOptions" />
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<style scoped>
</style>
<script>
    import { Line } from 'vue-chartjs'
    import { mapActions, mapState } from "vuex";
    import { numberWithCommas } from "../../mixins/numberMixins";
    function initialState() {
        return {
            saving: false,
            loading: false,
            lineOptions : {
                plugins: {
                    legend: {
                        display: true
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function (value, index, ticks) {
                                return '$' + value;
                            },
                        }
                    }
                }
            }
        };
    }
    export default {
        name: "ContactDetailsPanel",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        components: {
            Line
        },
        props: {
            contact: Object,
            hidePanels: Boolean
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
            ]),
            reset: function () {
                Object.assign(this.$data, initialState());
            },
            numberWithCommas
        },
        computed: {
            ...mapState({
                entityRecord: (state) => state.entities.entityRecord,
                entityRecordLoading: (state) => state.entities.entityRecordLoading
            }),
            showPanels() {
                return this.hidePanels == undefined || !this.hidePanels;
            },
            record() {
                return this.contact || this.entityRecord;
            },
            recordLoading() {
                return this.contact ? false : this.entityRecordLoading;
            },
            lineData() {
                if (this.record && this.record.monthlyPerformance) {
                    return {
                        labels: this.record.monthlyPerformance.map(item => { return this.$dayjs(item.day).format('MMM YY'); }),
                        datasets: [
                            {
                                label: 'Received',
                                fill: false,
                                tension: 0.1,
                                borderColor: '#00acc1',
                                data: this.record.monthlyPerformance.map(item => { return item.receivedTotal; })
                            },
                            {
                                label: 'Invoiced',
                                fill: true,
                                tension: 0.1,
                                borderColor: '#536dfe',
                                data: this.record.monthlyPerformance.map(item => { return item.invoiceTotal; })
                            },
                        ]
                    };
                }
                return { labels: [], datasets: [] };
            }
        }
    };
</script>